// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ClaimItemProposalDTO } from '../models';
import { CreateClaimItemProposalDTO } from '../models';
import { ReplaceClaimItemProposalDTO } from '../models';
/**
 * ClaimItemProposalsApi - axios parameter creator
 * @export
 */
export const ClaimItemProposalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a claim item proposal on a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {CreateClaimItemProposalDTO} createClaimItemProposalDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimItemProposal(claimId: string, claimProposalId: string, createClaimItemProposalDTO: CreateClaimItemProposalDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling createClaimItemProposal.');
            }
            // verify required parameter 'claimProposalId' is not null or undefined
            if (claimProposalId === null || claimProposalId === undefined) {
                throw new RequiredError('claimProposalId','Required parameter claimProposalId was null or undefined when calling createClaimItemProposal.');
            }
            // verify required parameter 'createClaimItemProposalDTO' is not null or undefined
            if (createClaimItemProposalDTO === null || createClaimItemProposalDTO === undefined) {
                throw new RequiredError('createClaimItemProposalDTO','Required parameter createClaimItemProposalDTO was null or undefined when calling createClaimItemProposal.');
            }
            const localVarPath = `/v2/claims/{claimId}/proposals/{claimProposalId}/item-proposals`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimProposalId"}}`, encodeURIComponent(String(claimProposalId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateClaimItemProposalDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createClaimItemProposalDTO !== undefined ? createClaimItemProposalDTO : {}) : (createClaimItemProposalDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a claim item proposal on a claim proposal
         * @param {string} claimProposalId Claim proposal id
         * @param {string} itemProposalId Claim Item proposal id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimItemProposal(claimProposalId: string, itemProposalId: string, claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimProposalId' is not null or undefined
            if (claimProposalId === null || claimProposalId === undefined) {
                throw new RequiredError('claimProposalId','Required parameter claimProposalId was null or undefined when calling deleteClaimItemProposal.');
            }
            // verify required parameter 'itemProposalId' is not null or undefined
            if (itemProposalId === null || itemProposalId === undefined) {
                throw new RequiredError('itemProposalId','Required parameter itemProposalId was null or undefined when calling deleteClaimItemProposal.');
            }
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling deleteClaimItemProposal.');
            }
            const localVarPath = `/v2/claims/{claimId}/proposals/{claimProposalId}/item-proposals/{itemProposalId}`
                .replace(`{${"claimProposalId"}}`, encodeURIComponent(String(claimProposalId)))
                .replace(`{${"itemProposalId"}}`, encodeURIComponent(String(itemProposalId)))
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace a claim item proposal on a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {string} itemProposalId Claim Item proposal id
         * @param {ReplaceClaimItemProposalDTO} replaceClaimItemProposalDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimItemProposal(claimId: string, claimProposalId: string, itemProposalId: string, replaceClaimItemProposalDTO: ReplaceClaimItemProposalDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling updateClaimItemProposal.');
            }
            // verify required parameter 'claimProposalId' is not null or undefined
            if (claimProposalId === null || claimProposalId === undefined) {
                throw new RequiredError('claimProposalId','Required parameter claimProposalId was null or undefined when calling updateClaimItemProposal.');
            }
            // verify required parameter 'itemProposalId' is not null or undefined
            if (itemProposalId === null || itemProposalId === undefined) {
                throw new RequiredError('itemProposalId','Required parameter itemProposalId was null or undefined when calling updateClaimItemProposal.');
            }
            // verify required parameter 'replaceClaimItemProposalDTO' is not null or undefined
            if (replaceClaimItemProposalDTO === null || replaceClaimItemProposalDTO === undefined) {
                throw new RequiredError('replaceClaimItemProposalDTO','Required parameter replaceClaimItemProposalDTO was null or undefined when calling updateClaimItemProposal.');
            }
            const localVarPath = `/v2/claims/{claimId}/proposals/{claimProposalId}/item-proposals/{itemProposalId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimProposalId"}}`, encodeURIComponent(String(claimProposalId)))
                .replace(`{${"itemProposalId"}}`, encodeURIComponent(String(itemProposalId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ReplaceClaimItemProposalDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(replaceClaimItemProposalDTO !== undefined ? replaceClaimItemProposalDTO : {}) : (replaceClaimItemProposalDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimItemProposalsApi - functional programming interface
 * @export
 */
export const ClaimItemProposalsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create a claim item proposal on a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {CreateClaimItemProposalDTO} createClaimItemProposalDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimItemProposal(claimId: string, claimProposalId: string, createClaimItemProposalDTO: CreateClaimItemProposalDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimItemProposalDTO> {
            const localVarAxiosArgs = ClaimItemProposalsApiAxiosParamCreator(configuration).createClaimItemProposal(claimId, claimProposalId, createClaimItemProposalDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a claim item proposal on a claim proposal
         * @param {string} claimProposalId Claim proposal id
         * @param {string} itemProposalId Claim Item proposal id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimItemProposal(claimProposalId: string, itemProposalId: string, claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = ClaimItemProposalsApiAxiosParamCreator(configuration).deleteClaimItemProposal(claimProposalId, itemProposalId, claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Replace a claim item proposal on a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {string} itemProposalId Claim Item proposal id
         * @param {ReplaceClaimItemProposalDTO} replaceClaimItemProposalDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimItemProposal(claimId: string, claimProposalId: string, itemProposalId: string, replaceClaimItemProposalDTO: ReplaceClaimItemProposalDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimItemProposalDTO> {
            const localVarAxiosArgs = ClaimItemProposalsApiAxiosParamCreator(configuration).updateClaimItemProposal(claimId, claimProposalId, itemProposalId, replaceClaimItemProposalDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClaimItemProposalsApi - factory interface
 * @export
 */
export const ClaimItemProposalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create a claim item proposal on a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {CreateClaimItemProposalDTO} createClaimItemProposalDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimItemProposal(claimId: string, claimProposalId: string, createClaimItemProposalDTO: CreateClaimItemProposalDTO, options?: any) {
            return ClaimItemProposalsApiFp(configuration).createClaimItemProposal(claimId, claimProposalId, createClaimItemProposalDTO, options)(axios, basePath);
        },
        /**
         * Delete a claim item proposal on a claim proposal
         * @param {string} claimProposalId Claim proposal id
         * @param {string} itemProposalId Claim Item proposal id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimItemProposal(claimProposalId: string, itemProposalId: string, claimId: string, options?: any) {
            return ClaimItemProposalsApiFp(configuration).deleteClaimItemProposal(claimProposalId, itemProposalId, claimId, options)(axios, basePath);
        },
        /**
         * Replace a claim item proposal on a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {string} itemProposalId Claim Item proposal id
         * @param {ReplaceClaimItemProposalDTO} replaceClaimItemProposalDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimItemProposal(claimId: string, claimProposalId: string, itemProposalId: string, replaceClaimItemProposalDTO: ReplaceClaimItemProposalDTO, options?: any) {
            return ClaimItemProposalsApiFp(configuration).updateClaimItemProposal(claimId, claimProposalId, itemProposalId, replaceClaimItemProposalDTO, options)(axios, basePath);
        },
    };
};

/**
 * ClaimItemProposalsApi - interface
 * @export
 * @interface ClaimItemProposalsApi
 */
export interface ClaimItemProposalsApiInterface {
    /**
     * Create a claim item proposal on a claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {CreateClaimItemProposalDTO} createClaimItemProposalDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemProposalsApiInterface
     */
    createClaimItemProposal(claimId: string, claimProposalId: string, createClaimItemProposalDTO: CreateClaimItemProposalDTO, options?: any): AxiosPromise<ClaimItemProposalDTO>;

    /**
     * Delete a claim item proposal on a claim proposal
     * @param {string} claimProposalId Claim proposal id
     * @param {string} itemProposalId Claim Item proposal id
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemProposalsApiInterface
     */
    deleteClaimItemProposal(claimProposalId: string, itemProposalId: string, claimId: string, options?: any): AxiosPromise<object>;

    /**
     * Replace a claim item proposal on a claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {string} itemProposalId Claim Item proposal id
     * @param {ReplaceClaimItemProposalDTO} replaceClaimItemProposalDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemProposalsApiInterface
     */
    updateClaimItemProposal(claimId: string, claimProposalId: string, itemProposalId: string, replaceClaimItemProposalDTO: ReplaceClaimItemProposalDTO, options?: any): AxiosPromise<ClaimItemProposalDTO>;

}

/**
 * ClaimItemProposalsApi - object-oriented interface
 * @export
 * @class ClaimItemProposalsApi
 * @extends {BaseAPI}
 */
export class ClaimItemProposalsApi extends BaseAPI implements ClaimItemProposalsApiInterface {
    /**
     * Create a claim item proposal on a claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {CreateClaimItemProposalDTO} createClaimItemProposalDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemProposalsApi
     */
    public createClaimItemProposal(claimId: string, claimProposalId: string, createClaimItemProposalDTO: CreateClaimItemProposalDTO, options?: any) {
        return ClaimItemProposalsApiFp(this.configuration).createClaimItemProposal(claimId, claimProposalId, createClaimItemProposalDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete a claim item proposal on a claim proposal
     * @param {string} claimProposalId Claim proposal id
     * @param {string} itemProposalId Claim Item proposal id
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemProposalsApi
     */
    public deleteClaimItemProposal(claimProposalId: string, itemProposalId: string, claimId: string, options?: any) {
        return ClaimItemProposalsApiFp(this.configuration).deleteClaimItemProposal(claimProposalId, itemProposalId, claimId, options)(this.axios, this.basePath);
    }

    /**
     * Replace a claim item proposal on a claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {string} itemProposalId Claim Item proposal id
     * @param {ReplaceClaimItemProposalDTO} replaceClaimItemProposalDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemProposalsApi
     */
    public updateClaimItemProposal(claimId: string, claimProposalId: string, itemProposalId: string, replaceClaimItemProposalDTO: ReplaceClaimItemProposalDTO, options?: any) {
        return ClaimItemProposalsApiFp(this.configuration).updateClaimItemProposal(claimId, claimProposalId, itemProposalId, replaceClaimItemProposalDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ClaimItemProposalsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Create a claim item proposal on a claim proposal
 * @param {string} claimId Claim id
 * @param {string} claimProposalId Claim proposal id
 * @param {CreateClaimItemProposalDTO} createClaimItemProposalDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createClaimItemProposal(
    claimId: string,
    claimProposalId: string,
    createClaimItemProposalDTO: CreateClaimItemProposalDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimItemProposalDTO> {
    const localVarAxiosArgs = ClaimItemProposalsApiAxiosParamCreator(configuration).createClaimItemProposal(claimId, claimProposalId, createClaimItemProposalDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a claim item proposal on a claim proposal
 * @param {string} claimProposalId Claim proposal id
 * @param {string} itemProposalId Claim Item proposal id
 * @param {string} claimId Claim id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteClaimItemProposal(
    claimProposalId: string,
    itemProposalId: string,
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = ClaimItemProposalsApiAxiosParamCreator(configuration).deleteClaimItemProposal(claimProposalId, itemProposalId, claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Replace a claim item proposal on a claim proposal
 * @param {string} claimId Claim id
 * @param {string} claimProposalId Claim proposal id
 * @param {string} itemProposalId Claim Item proposal id
 * @param {ReplaceClaimItemProposalDTO} replaceClaimItemProposalDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateClaimItemProposal(
    claimId: string,
    claimProposalId: string,
    itemProposalId: string,
    replaceClaimItemProposalDTO: ReplaceClaimItemProposalDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimItemProposalDTO> {
    const localVarAxiosArgs = ClaimItemProposalsApiAxiosParamCreator(configuration).updateClaimItemProposal(claimId, claimProposalId, itemProposalId, replaceClaimItemProposalDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

